import React, { useState, useEffect } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import cards from "../Assets/image 9.png";
import img from "../Assets/Group 1000002189.png";
import { getCartByUser, placeBooking } from "../Common/apis";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader.jsx";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../Components/Navbar2.jsx";
import Footer2 from "../Components/Footer2.jsx";
import Aos from "aos";

function Checkout2() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    fullAddress: "",
    mobile: "",
    landmark: ""
  });

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    const token = localStorage.getItem("GISUL_TOKEN");
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const response = await getCartByUser();
      setCart(response?.data?.courses || []);
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePlaceOrder = async () => {
    if (!formData.name || !formData.fullAddress || !formData.mobile) {
      toast.error("Please fill all required fields");
      return;
    }
    setLoading(true);
    try {
      const bookingData = {
        courses: cart.map((item) => ({
          course: item.course._id,
          quantity: item.quantity,
          price: item.course.price
        })),
        address: formData,
        payment: {
          amount: cart.reduce(
            (acc, item) => acc + item.quantity * item.course.price,
            0
          )
        }
      };
      await placeBooking(bookingData);
      toast.success("Order placed successfully");
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="new-home">
      {/* <Navbar /> */}
      <Navbar2 />
      {loading && <Loader />}
      {/* <div className='new-home-center new-home-center2'>
        <h2>Checkout Page</h2>
        <p>(1 item) $99.25</p>
    </div>
    <br/>
    <br/>
    <div className='checkout-div'>
    <div className='checkout-div-left'>
    <h3>CONTACT</h3>
    <input placeholder='Email'/>
    <br/>
    <br/>
    <br/>
    <h3>ADDRESS</h3>
    <input placeholder='Full Name'/>

    <input placeholder='Address'/>

    <input placeholder='City'/>

    <input placeholder='Postal Code'/>
    <input placeholder='Phone'/>
    <br/>
    <br/>
    <div className='check-div'>
    <input type='checkbox'/>
    <p>Save time at checkout - create an account to store your address</p>
        
    </div>
    <br/>

    <div className='check-div'>
    <input type='checkbox'/>
    <p>Save time at checkout - create an account to store your address</p>
        
    </div>
    <br/>
    <h3>PAYMENT</h3>
    <br/>
    <div className='pay-lock'>
    <p>Payments are SSL encrypted so that your credit card and payment details stay safe.</p>
    </div>
    <br/>
    <div className='credit-box'>
    <h3>Credit/Debit Card</h3>
    <img src={cards}/>

    </div>
    <br/>
    <div className='credit-box'>
    <h3>Credit/Debit Card</h3>
    <img src={cards}/>

    </div>
    <br/>
<button>Place Order</button>
    

</div>
<div className='checkout-div-right'>
<div className='checkout-div-p'>
    <h3>Your Order</h3>
    <p>Edit</p>

</div>
<br/>
<br/>
<div className='checkout-div-p'>
    <p>1 item</p>
    <p>$99.25</p>

</div>
<div className='checkout-div-p'>
    <p>1 item</p>
    <p>$99.25</p>

</div>
<div className='checkout-div-p'>
    <p>1 item</p>
    <p>$99.25</p>

</div>
<br/>
<br/>
<div className='checkout-div-p'>
    <p>1 item</p>
    <p>$99.25</p>

</div>
<br/>
<div className='checkout-div-p'>
   <h3>USE VOUCHER CODE</h3>

</div>
<br/>
<div className='aws'>
<img src={img}/>
<div>
<h3>AWS Skill Builder</h3>
    <p>$99.25</p>
</div>
</div>
    </div>
</div> */}

      <div data-aos="fade-up" className="new-home-center new-home-center2">
        <h2>Checkout Page</h2>
        <p>({cart.length} items)</p>
      </div>
      <div className="checkout-div">
        <div className="checkout-div-left overflow-hidden">
          <h3 data-aos="fade-right">CONTACT</h3>
          <input data-aos="fade-left"
            name="email"
            placeholder="Email"
            onChange={handleInputChange}
          />
          <div className="pt-[34px] flex flex-col gap-[16px]">
            <h3 data-aos="fade-right">ADDRESS</h3>
            <input
            data-aos="fade-left"
              name="name"
              placeholder="Full Name"
              onChange={handleInputChange}
            />
            <input
            data-aos="fade-right"
              name="fullAddress"
              placeholder="Full Address"
              onChange={handleInputChange}
            />
            <input
            data-aos="fade-left"
              name="landmark"
              placeholder="Landmark"
              onChange={handleInputChange}
            />
            <input
            data-aos="fade-right"
              name="mobile"
              placeholder="Phone"
              onChange={handleInputChange}
            />
            <div data-aos="fade-left" className="flex items-center gap-[8px]">
              <input style={{ width: "20px", borderRadius: "2px", }} type="checkbox" name="" className="h-[20px] w-[20px]" id="" />
              <p className="font-sans font-[400] text-[12px] text-[#FFFFFF]">Save time at checkout – create an account to store your address</p>
            </div>
            <div data-aos="fade-right" className="flex items-center gap-[8px]">
              <input style={{ width: "20px", borderRadius: "2px", }} type="checkbox" name="" className="h-[20px] w-[20px]" id="" />
              <p className="font-sans font-[400] text-[12px] text-[#FFFFFF]">Billing and delivery address are the same</p>
            </div>
            <h3 data-aos="fade-left">PAYMENT</h3>
            <div className="credit-box">
              <h3 data-aos="fade-right">Credit/Debit Card</h3>
              <img data-aos="fade-left" src={cards} />
            </div>
            <button data-aos="flip-up" onClick={handlePlaceOrder}>Place Order</button>
          </div>
        </div>
        <div className="checkout-div-right">
          <h3 data-aos="fade-left">Your Order</h3>
          {cart.length === 0 ? (
            <p>No items in cart</p>
          ) : (
            cart.map((item) => (
              <div key={item.course._id} className="aws">
                <img
                  src={item?.course?.images?.[0] || img}
                  alt={item.course.name}
                // style={{ width: "100px", height: "100px" }}
                />
                <div className="flex flex-col gap-[16px]">
                  <h3 className="m-0">{item.course.name}</h3>
                  <p className="m-0">
                    ${item.course.price} x {item.quantity}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <Footer2 />
    </div>
  );
}

export default Checkout2;
